<template>
  <div class="flex dashboard">

    <!--    看板头部-->
    <div class="dashboard-header">
      <!--      工具栏-->
      <div class="tab-box flex align-center justify-between">
        <!--        左边-->
        <div class="flex align-center">
          <!--          tab切换-->
          <gj-radio-group
              v-model="activeTab"
              :options="$permission('allStoreDashboard:view')?tabOption:[tabOption[0]]"
          ></gj-radio-group>

          <template v-if="activeTab === 'sale'">

            <!--          时间-->
            <i class="iconfont iconshijian size12" style="margin: 0 4px 0 16px;line-height: 1;"></i>

            <span v-if="timeActive.id" class="size12 colorBlue" style="line-height: 1;width: 210px;">
              {{timeActive.timezone}}：{{timeActive.text}}
            </span>

            <el-carousel
                v-else
                ref="gjCarousel"
                :autoplay="autoplay"
                :loop="true"
                indicator-position="none"
                arrow="never"
                :interval="5000"
                height="12px"
                style="width: 210px;font-size: 12px;line-height: 1;margin-bottom: 2px;"
            >
              <el-carousel-item v-for="(item,index) in clockData" :key="index">
                {{item.timezone}}:{{item.text}}
              </el-carousel-item>
            </el-carousel>

            <!--          钟表框开关-->
            <gj-button type="text" class="color333" style="margin: 0 16px 0 0;padding: 0;" @click="openClock">
              {{ timeActive.id ? '已选择时区' : '选择时区' }}
              <i class="iconfont iconxiala size12 color999" :class="{'iconxiala-open':showClock}"></i>
            </gj-button>
            <!--          节日-->
            <template>
              <div
                  v-for="(day,index) in holidayData" :key="index"
                  class="size12 colorPurple flex align-center" style="padding-left: 4px;line-height: 1;"
              >
                <i class="iconfont iconliwu1 size12 colorPurple" style="padding-right: 4px;line-height: 1;"></i>
                <span>{{day.text}}</span>
                <gj-icon
                    v-for="flag in day.countrys"
                    :key="flag"
                    :iconfont="getFlag(flag)"
                    style="font-size: 26px;margin-left: 8px;"
                ></gj-icon>
              </div>
            </template>

          </template>


        </div>
        <!--        右边  币种选择-->
        <div class="flex" v-if="activeTab === 'sale'">
          <gj-country-server-select
              v-model="countryMarket"
              @input="countryChange"
          ></gj-country-server-select>
          <gj-select
              v-model="currency"
              :options="financeCurrencysOption"
              :clearable="false"
              @change="currencyChange"
              style="margin-left: 8px;"
          >
          </gj-select>
        </div>
      </div>
      <!--      钟表选择框-->
      <transition name="clock">
        <div v-if="showClock && activeTab==='sale'" class="panel">
          <app-clock-group :clockData="clockData" :activeId="timeActive.id" @clockChange="clockChange"></app-clock-group>
        </div>
      </transition>

    </div>

    <!--    看板主体-->
    <div class="dashboard-main">

      <!--      销售看板-->
      <div v-if="activeTab === 'sale'" class="dashboard">
        <div v-record-scroll
             class="content-wrapper">


          <el-row :gutter="10" class="gutter-bottom">

            <el-col :span="16">

              <el-row class="gutter-bottom">
                <!-- 今日看板 -->
                <app-dashboard-sale-instant/>
              </el-row>

              <el-row>
                <!--                工作台-->
                <app-workbench/>
              </el-row>

            </el-col>

            <el-col :span="8">
              <!--              广告即时看板-->
              <app-ad-immediate-board/>
            </el-col>

          </el-row>


          <!-- 销售报告 and 广告报告 -->
          <el-row :gutter="10" class="gutter-bottom" style="background-color: #fff;margin: 10px 0;">

            <!--            筛选工具栏-->
            <app-filter-group
                class="sale-ad-filter"
                style="padding: 6.5px 16px;width: auto"
                ref="app-filter-group"
                :query="false"
                :reset="false"
            >
              <div class="flex align-center" style="height: 33px;">
                <i class="iconfont iconshujubaogao"></i>
                <span class="size14 area-tit">销售和广告趋势报告</span>
              </div>

              <transition name="filter">
                <div v-show="saleShow" class="flex">
                  <gj-radio-group
                      v-model="filter.dateType"
                      :options="[
                    {id: 'seven', text: '近7天'},
                    {id: 'fourteen', text: '近14天'},
                    {id: 'thirty', text: '近30天'},
                     {id: 'week', text: '本周'},
                    {id: 'month', text: '本月'},
                    {id: '', text: '自定义'},
                  ]"
                      style="margin: 0 8px;"
                      @change="saleAdQuery"
                  ></gj-radio-group>
                  <gj-date-picker
                      v-if="filter.dateType===''"
                      class="dashboard-date"
                      v-model="filter.date"
                      :shortcut="false"
                      type="daterange"
                      :clearable="false"
                      @change="saleAdQuery"
                  ></gj-date-picker>
                </div>
              </transition>

              <template #right>
                <gj-button type="iconfont" :iconfont="saleShow?'iconshouqi1':'iconsuofang'" size="14px" @click="setSaleShow"></gj-button>
              </template>
            </app-filter-group>

            <transition name="salePanelMask">
              <app-mask  v-if="saleShow" :top="'42px'" :right="'19px'"></app-mask>
            </transition>


            <!--            折叠筐中dom变动，高度变化时，需在css中改变写死（也可用js取滚动高度）-->
            <transition name="salePanel">
              <div v-if="saleShow" class="panel">
                <div>
                  <!--        销售报告-->
                  <el-col :span="12" style="padding: 0;">
                    <app-dashboard-sale-report
                        ref="saleReport"
                        :date="filter.date"
                        :dateType="filter.dateType"
                    ></app-dashboard-sale-report>
                  </el-col>
                  <!--        广告报告-->
                  <el-col :span="12" style="padding: 0;">
                    <app-dashboard-ad-report
                        ref="adReport"
                        :date="filter.date"
                        :dateType="filter.dateType"
                    ></app-dashboard-ad-report>
                  </el-col>
                </div>
              </div>
            </transition>
          </el-row>

          <!--          商品销售看板-->
          <el-row class="gutter-bottom">
            <app-dashboard-sale-instant-table/>
          </el-row>

          <!-- 绩效看板 and 索赔面板 -->
          <el-row :gutter="10" class="gutter-bottom">
            <el-col :span="16">
              <!-- 绩效看板 -->
              <app-dashboard-achievements />
            </el-col>
            <el-col :span="8">
              <!-- 索赔面板 -->
              <app-dashboard-claim-demage />
            </el-col>
          </el-row>

          <!-- 排行榜 and 公告日志 -->
          <el-row :gutter="10" class="gutter-bottom gutter-no-bottom">
            <el-col :span="16">
              <!-- 排行榜 -->
              <app-dashboard-rank/>
            </el-col>
            <el-col :span="8">
              <!-- 公告日志 -->
              <app-dashboard-notice/>
            </el-col>
          </el-row>

        </div>
      </div>
      <!--      全店铺看板-->
      <div v-if="activeTab === 'store'" style="height: 100%;padding-bottom: 16px;box-sizing: border-box;">
        <app-shop-wide-analysis/>
      </div>

    </div>

  </div>
</template>

<script>
import AppClockGroup from "./components/clock/clock-group"
import AppDashboardSaleInstant from "../components/sale/dashoboard-sale-instant";
import AppDashboardSaleReport from "../components/sale/dashboard-sale-report";
import AppDashboardRank from "../components/rank/dashboard-rank";
import AppDashboardAdReport from "../components/ad/dashboard-ad-report";
import AppDashboardNotice from "../components/notice/dashboard-notice";
import AppDashboardSaleInstantTable from "@/views/modules/home/components/sale/dashboard-sale-instant-table";
import AppWorkbench from "./components/workbench/workbench"
import AppAdImmediateBoard from "./components/ad-immediate-board/ad-immediate-board"
import AppDashboardAchievements from "./components/statistics/achievements"
import AppDashboardClaimDemage from "./components/claim/claim-demage"

import AppShopWideAnalysis from "@/views/modules/statistics/shop-wide-analysis/shop-wide-analysis"

import {isMeaningful, isMeaningless} from "@/utils/common";
import { getHoliday, getTimezoneDate} from "@/api/dashboard";
import { countryOption } from "@/utils/options";
import {queryMixin} from "@/minxins";
import AppMask from "@/views/modules/home/components/mask/mask";
import {DASHBOARD_REFRESH_MARKET_AUTH_TYPE} from "@/store/action-types";
import Cookies from "js-cookie";
import {AUTH_ACCOUNT, AUTH_USER_ID} from "@/utils/auth";
import {
  DASHBOARD_SET_COUNTRY_MARKET,
  DASHBOARD_SET_CURRENCY,
  DASHBOARD_SET_TIMEZONE_ID,
  DASHBOARD_SET_TIMEZONE_TEXT
} from "@/store/mutation-types";
import {mapGetters} from "vuex";

export default {
  name: "app-dashboard",
  mixins: [queryMixin],
  components: {
    AppDashboardNotice,
    AppDashboardAdReport,
    AppDashboardRank,
    AppDashboardSaleReport,
    AppDashboardSaleInstant,
    AppDashboardSaleInstantTable,
    AppClockGroup,
    AppWorkbench,
    AppAdImmediateBoard,
    AppShopWideAnalysis,
    AppMask,
    AppDashboardAchievements,
    AppDashboardClaimDemage
  },
  data() {
    return {
      tabOption:[
        {id: 'sale', text: '销售看板'},
        {id: 'store', text: '全店铺看板'}
      ],

      financeCurrencysOption:[
        {id: 'USD', text: 'USD'}, // 美国
        {id: 'JPY', text: 'JPY'}, // 日本
        {id: 'CAD', text: 'CAD'}, // 加拿大
        {id: 'GBP', text: 'GBP'}, // 英镑
        {id: 'EUR', text: 'EUR'}, // 欧元
        {id: 'AUD', text: 'AUD'}, // 澳元
        {id: 'BRL', text: 'BRL'}, // 巴西雷亚尔
        {id: 'INR', text: 'INR'}, // 印度
        {id: 'CNY', text: 'CNY'}, // 人名币
        {id: 'MXN', text: 'MXN'}, // 墨西哥
        {id: 'HKD', text: 'HKD'}, // 香港
        {id: 'AED', text: 'AED'}, // 阿联酋
        {id: 'SAR', text: 'SAR'}, //
        {id: 'TRY', text: 'TRY'}, //
      ],
      activeTab: 'sale',// 销售看板sale\全店铺看板store
      showClock: false,// 显示钟表框
      saleShow: false,// 销售报告和广告报告 展开收起

      countryMarket: null,// 国家、店铺
      currency: 'USD',// 当前币种
      timeActive: {id:'',timezone:'',time:'',text:''},// 当前选中的时间

      clockData:[],// 钟表时间列表
      holidayData:[],// 节日列表

      filter: {
        // date: [subDays(new Date(), 13), new Date()],
        date: null,
        dateType: 'seven'
      },

      filter2: {},


      shortcutText: null,
      option: {
        timezone: [],
      },
      timezoneCodes: [],
      cacheOptions: {
        useCache: true
      },

      autoplay: true // 走马灯自动切换
    };
  },
  beforeRouteEnter(to,from,next){
    next(async vm=>{
      // 设置币种
      vm.$store.commit(DASHBOARD_SET_CURRENCY, Cookies.get(Cookies.get(AUTH_USER_ID)+'Currency')||'USD');
      vm.currency =  Cookies.get(Cookies.get(AUTH_USER_ID)+'Currency')||'USD';

      // 设置选中的时区id
      vm.$store.commit(DASHBOARD_SET_TIMEZONE_ID, Cookies.get(Cookies.get(AUTH_USER_ID)+'TimeActive'));
      vm.timeActive.id = Cookies.get(Cookies.get(AUTH_USER_ID)+'TimeActive');

      // 设置销售和广告报告模块的展开状态
      vm.saleShow = Cookies.get(Cookies.get(AUTH_USER_ID)+'SaleShow')!=='0';

      // 获取店铺授权状态  用于显示蒙板
      await vm.$store.dispatch(DASHBOARD_REFRESH_MARKET_AUTH_TYPE);

      // 获取节日
      vm.getHoliday()
      if (vm._timer) clearInterval(vm._timer);
      vm.getTimezoneDate()
      vm._timer = setInterval(() => {
        vm.getTimezoneDate()
      }, 5000);
    })
  },
  activated() {
    this.autoplay = true;
  },
  deactivated() {
    this.autoplay = false;
  },
  destroyed(){
    this.autoplay = false;
    if (this._timer) clearInterval(this._timer);
  },
  computed:{
    ...mapGetters(['timezoneId','timezoneText']),
  },
  methods: {
    countryChange(){
      this.$store.commit(DASHBOARD_SET_COUNTRY_MARKET, this.countryMarket);
    },
    // 币种切换回调
    currencyChange(val){
      this.$store.commit(DASHBOARD_SET_CURRENCY, val);
      Cookies.set(Cookies.get(AUTH_USER_ID)+'Currency', val, {expires:14})
    },

    //获取时区时间
    getTimezoneDate() {
      getTimezoneDate().then((data) => {
        if (data && data.length > 0) {
          this.clockData = data;
          // 若有id且没有text时（有缓存时区时，第一次进入页面），重新设置当前选中时区
          if(isMeaningful(this.timezoneId)&&isMeaningless(this.timezoneText)){
            this.clockChange(data.find(r=>r.id===this.timeActive.id));
          } else if(isMeaningful(this.timezoneId)) { // 后续更新时间
            this.timeActive = data.find(r=>r.id===this.timeActive.id);
          }
        }
      });
    },
    // 打开钟表框
    openClock(){
      if(!this.showClock){
        this.getTimezoneDate()
      }
      this.showClock=!this.showClock;
    },
    // 选中时间改变
    clockChange(clock) {
      this.timeActive = clock;
      // 本地缓存选中的时区id
      this.$store.commit(DASHBOARD_SET_TIMEZONE_ID, clock.id);
      this.$store.commit(DASHBOARD_SET_TIMEZONE_TEXT, clock.text);
      Cookies.set(Cookies.get(AUTH_USER_ID)+'TimeActive', clock.id||'', {expires:14})
      this.getHoliday()
    },

    // 切换、存储 销售和广告报告模块 的展开状态 不同用户userId不同
    setSaleShow(){
      this.saleShow = !this.saleShow;
      Cookies.set(Cookies.get(AUTH_USER_ID)+'SaleShow', this.saleShow?1:0, {expires:14})
    },
    // 获取国旗 icon
    getFlag(flag){
      return countryOption.find(r => r.id === flag).icon
    },
    // 获取节日
    getHoliday(){
      if(isMeaningful(this.timezoneId)&&isMeaningless(this.timezoneText)){
        return
      }
      getHoliday(`marketTime=${this.timezoneText}`).then(res=>{
        if(res&&res.length>0){
          this.holidayData = res;
          this.holidayData.forEach(r=>{
            if(r.id){
              r.countrys = r.id.split(',')
            }
          })
        }
      })
    },
    // 销售和广告报告 点击查询
    saleAdQuery() {
      if (this.filter.dateType === '' && !this.filter.date) {
        // this.$message.warning('请先选择时间段');
        return
      }
      this.$refs.saleReport.$gjQuery();
      this.$refs.adReport.$gjQuery();
    },
    // $gjCacheCallback(params) {
    //   return {
    //     countryMarket: params.countryMarket,
    //   };
    // },
    // query() {
    //   this.filter.date = [...this.filter.date];
    //   if (isMeaningful(this.filter.timezone.key)) {
    //     this.refreshTimezone({id: this.filter.timezone.key});
    //   } else {
    //     this.refreshTimezone();
    //   }
    // },
    // refreshTimezone(option) {
    //   // 获取数据计算时间
    //   getInstantSaleTime()
    //       .then((data) => {
    //         if (data && data.length > 0) {
    //           this.option.timezone = data
    //               .filter(item => this._.size(this.timezoneCodes) === 0 || this.timezoneCodes.includes(item.id))
    //               .map(item => ({
    //                 id: item.id,
    //                 text: optionText(item.id, timezoneOption),
    //                 time: item.text || '各个站点市场时间'
    //               }));
    //           if (this.option.timezone.length > 0) {
    //             if (isMeaningful(option)) {
    //               this.timezoneOptionInput(this.option.timezone.find(item => item.id === option.id));
    //             } else {
    //               this.timezoneOptionInput(this.option.timezone[0]);
    //             }
    //           }
    //         }
    //       });
    // },
    // timezoneOptionInput(option) {
    //   this.filter.timezone = {
    //     key: option.id,
    //     value: option.time
    //   };
    // },
    // marketOptionInput(options) {
    //   this.timezoneCodes = this._.uniq((options || []).map(item => {
    //     const find = countryOption.find(countryOption => countryOption.id === item.countryCode);
    //     return find ? find.timezone : null;
    //   }).filter(e => isMeaningful(e)));
    //   this.refreshTimezone();
    //   this.$nextTick(_ => {
    //     this.setCacheData()
    //   })
    // }
  }
}
</script>

<style lang="scss" scoped>
@import "../common";

.dashboard {
  flex-direction: column;
  height: 100%;

  .dashboard-header {
    padding: 12px 0 10px;
    /deep/ .el-carousel__item{
      div{
        height: 20px;
        line-height: 20px;
      }
    }
  }

  .dashboard-main {
    overflow-y: auto;
    flex: 1;
  }
}
.sale-ad-filter{
  /deep/ .query-button{
    margin-left: 0!important;
  }
}
/deep/ .dashboard-date {
  margin-right: 8px;

  .el-range-input {
    background: #fff;
  }
}

.filter-group {
  justify-content: space-between;
}

/deep/ .operate-group {
  margin: 0 !important;
}

.panel {
  overflow: hidden;
  will-change: height;
}

.salePanelMask-enter-active, .salePanelMask-leave-active, .filter-enter-active, .filter-leave-active {
  transition: opacity .3s;
}
.salePanelMask-enter, .salePanelMask-leave-to, .filter-enter, .filter-leave-to {
  opacity: 0;
}

.salePanel-enter-active, .salePanel-leave-active {
  height: 427px;
  transition: height .3s;
}

.clock-enter-active, .clock-leave-active {
  height: 117px;
  transition: height .3s;
}

.salePanel-enter, .salePanel-leave-to, .clock-enter, .clock-leave-to {
  height: 0;
}

.tab-box {
  padding: 0 16px;

  .iconxiala {
    display: inline-block;
    transform: rotate(0deg) scale(.65);
    transition: transform .3s;
  }

  .iconxiala-open {
    transform: rotate(-180deg) scale(.65);
  }
}

/deep/ .iconshuaxin {
  margin: 0 8px 0 10px;
  font-size: 14px;
  color: #999;
  cursor:pointer;
}
/deep/ .area-tit{
  font-weight: 600;
  height: 14px;
  line-height: 1;
  padding: 0 10px 0 8px;
}
</style>

